import { t as e } from "./utils-DiFe-_ei.js";
import { Button as t } from "./foundations/button.js";
import "./button-C8zrAH2m.js";
import { t as n } from "./chevron-left-ObWP-3BV.js";
import { t as r } from "./chevron-right-C4-3WHKK.js";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/navigation/Pagination/Pagination.tsx
function o({ page: o, pageCount: s, onPageChange: c, summary: l, className: u }) {
	return s <= 1 ? null : /* @__PURE__ */ a("nav", {
		"aria-label": "Pagination",
		className: e("flex items-center justify-between gap-3 pt-3", u),
		children: [/* @__PURE__ */ i("span", {
			className: "text-muted-foreground text-xs tabular-nums",
			children: l
		}), /* @__PURE__ */ a("div", {
			className: "flex items-center gap-1",
			children: [
				/* @__PURE__ */ i(t, {
					type: "button",
					variant: "ghost",
					size: "icon",
					className: "size-8 rounded-full",
					"aria-label": "Previous page",
					disabled: o <= 1,
					onClick: () => c(o - 1),
					children: /* @__PURE__ */ i(n, {
						className: "size-4",
						"aria-hidden": "true"
					})
				}),
				/* @__PURE__ */ a("span", {
					className: "text-muted-foreground min-w-14 text-center text-xs tabular-nums",
					children: [
						"Page ",
						o,
						" of ",
						s
					]
				}),
				/* @__PURE__ */ i(t, {
					type: "button",
					variant: "ghost",
					size: "icon",
					className: "size-8 rounded-full",
					"aria-label": "Next page",
					disabled: o >= s,
					onClick: () => c(o + 1),
					children: /* @__PURE__ */ i(r, {
						className: "size-4",
						"aria-hidden": "true"
					})
				})
			]
		})]
	});
}
//#endregion
export { o as t };

//# sourceMappingURL=Pagination-Dh2R94_t.js.map